<template>
  <div class="p-0 m-0 sticky left-0 h-auto w-full">
    <!-- <topBar/> -->
  <NavBar />
    <div class="flex items-center gap-4 absolute right-5 top-5 z-[300]">
            <button @click="toggleTheme" class="p-2 rounded-full bg-gray-700/50 hover:bg-gray-600/50 transition-colors">
              <svg class="w-5 h-5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="darkMode" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            </button>
          </div>
     <AiChat />
    <router-view ref="view" class="max-sm:pb-10"/>
  </div>
</template>

<script setup>
import NavBar from "@/components/NavBar.vue"
import AiChat from "@/components/ChatButton.vue";

import { ref, onMounted, onUnmounted } from "vue";

const view = ref(null);

  const darkMode = ref(true)

const checkScroll = () => {
  if (view.value && view.value.checkScroll) {
    view.value.checkScroll();
  }
}




const toggleTheme = () => {
  darkMode.value = !darkMode.value
  if (darkMode.value) {
    document.documentElement.classList.remove('light-mode')
    document.documentElement.classList.add('dark-mode')
  } else {
    document.documentElement.classList.remove('dark-mode')
    document.documentElement.classList.add('light-mode')
  }
  localStorage.setItem('darkMode', darkMode.value)
}

onMounted(() => {
  const savedMode = localStorage.getItem('darkMode')
  if (savedMode !== null) {
    darkMode.value = savedMode === 'true'
    document.documentElement.classList.toggle('light-mode', !darkMode.value)
  }
  window.addEventListener("scroll", checkScroll);
})


onUnmounted(() => {
  window.removeEventListener("scroll", checkScroll);
});

</script>


<style lang="scss">
html {
  background-color: #232323;
  overflow-x: hidden;
}
.page-container {
  position: relative;
  background-color: #232323;
  top: 0;
  left: 0;
  overflow: hidden;
  height: auto;
  width: 100%;
  
}

@media not all and (min-width: 640px) {
   .page-container  {
        padding-bottom: 15vh;
    }
}


</style>
